module.exports = __webpack_public_path__ + "img/11.af24b4fc.jpg";